<div class="modal-header">
  <h4 class="modal-title pull-left">Report History</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span>
  </div>
</div>

<div class="modal-body history-container">
  <!-- Loading -->
  <div class="spinner" *ngIf="isLoading">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
    <h6 class="text">Loading</h6>
  </div>

  <!-- History Details List -->
  <div *ngIf="!isLoading && historyDetails.length">
    <div [ngClass]="{'border-bottom': !last}" class="history-item"
         *ngFor="let detail of historyDetails; let last = last">
      <div class="mb-2">
        <span><span class="ques-title">Question</span> : {{detail?.prevJson?.schema?.question?.label}} </span>
      </div>

      <div class="previous-data-wrapper mb-1">
        <div><span><span class="ques-label">Previous Answer</span> : {{detail?.prevJson?.schema?.question?.value ?? '-'}}</span></div>
      </div>
      <div class="current-data-wrapper">
        <div><span><span class="ques-label">Current Answer</span> : {{detail?.currentJson?.schema?.question?.value ?? '-'}}</span></div>
      </div>
    </div>
  </div>

  <!-- No History found Message -->
  <div class="no-history-msg" *ngIf="!historyDetails.length && dataLoaded">
    No History Found
  </div>

  <!-- Pagination -->
  <div style="width:100%;text-align:right;" *ngIf="totalItems > 20" class="pagination-wrapper">
    <pagination [totalItems]="totalItems" [itemsPerPage]="20" [(ngModel)]="currentPage" [maxSize]="5"
                [boundaryLinks]="true"
                [rotate]="false" (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
</div>
